<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType" id="msgWnd"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div class="col-9">
      <b-card>
        <template v-slot:header>
          <strong>PVI National Report Email Settings </strong><sub><i> only visible for MSIS internal staff</i></sub>
          <button id="btnSave" class="btn btn-info ml-auto pull-right" @click="savePVIReportSettings"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>

        </template>
        <b-row class="pt-2">
          <b-col lg="7">
            <label>Report Name</label>
            <b-form-input id="inpPVIRptName" type="text" v-model="setting.EMAIL_REPORT_NAME" :maxlength="50"
                          v-validate="{required: true}"
                          v-bind:class="{'is-invalid': validateErrors.has('Report Name') }"
                          name="Report Name"></b-form-input>
          </b-col>
          <b-col lg="2">
            <label>Results per Class</label>
            <dx-number-box id="inpPVIRptRows" class="form-control" v-model="setting.EMAIL_REPORT_ROWS"
                           v-validate="{required: true, min_value: 1, max_value:100}"
                           name="Results per class"
                           :min="1"
                           :max="100"
                           :isValid="HasError('Results per class')"
                           :validationError="GetError('Results per class')"></dx-number-box>
          </b-col>
          <b-col lg="3" style="padding-top:33px; align-content:flex-end">
            <label>Email National Average Report</label>
            <c-switch v-model="setting.EMAIL_REPORT" type="text" variant="primary" on="On" off="Off" :pill="true" />
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col>
            <label>Subject</label>
            <b-form-input id="inpPVIRptSubject" type="text" v-model="setting.EMAIL_SUBJECT" :maxlength="150"
                          v-validate="{required: true}"
                          v-bind:class="{'is-invalid': validateErrors.has('Subject') }"
                          name="Subject"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col>
            <label>Email Body</label>
            <!--<b-form-textarea id="inpPVIRptBody" type="text" v-model="setting.EMAIL_BODY" :maxlength="500" :rows="4"
           v-validate="{required: true}"
           v-bind:class="{'is-invalid': validateErrors.has('Step7.Body') }"
           name="Body"></b-form-textarea>-->
            <div>
              <DxHtmlEditor v-model="setting.EMAIL_BODY" value-type="html" min-height="250px"
                            id="inpPVIRptBody" name="Body" v-validate="{required: true}"
                            v-bind:class="{'is-invalid': validateErrors.has('Body') }">
                <DxMediaResizing :enabled="false" />
                <DxToolbar :multiline="true">
                  <DxItem format-name="undo" />
                  <DxItem format-name="redo" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="bold" />
                  <DxItem format-name="italic" />
                  <DxItem format-name="strike" />
                  <DxItem format-name="underline" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="alignLeft" />
                  <DxItem format-name="alignCenter" />
                  <DxItem format-name="alignRight" />
                  <DxItem format-name="alignJustify" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="orderedList" />
                  <DxItem format-name="bulletList" />
                  <DxItem format-name="separator" />
                  <DxItem :format-values="sizeValues" format-name="size" />
                  <DxItem :format-values="fontValues" format-name="font" />
                  <DxItem :format-values="headerValues" format-name="header" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="color" />
                  <DxItem format-name="background" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="link" />
                  <DxItem format-name="image" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="clear" />
                  <DxItem format-name="codeBlock" />
                  <DxItem format-name="blockquote" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="insertTable" />
                  <DxItem format-name="deleteTable" />
                  <DxItem format-name="insertRowAbove" />
                  <DxItem format-name="insertRowBelow" />
                  <DxItem format-name="deleteRow" />
                  <DxItem format-name="insertColumnLeft" />
                  <DxItem format-name="insertColumnRight" />
                  <DxItem format-name="deleteColumn" />
                </DxToolbar>
              </DxHtmlEditor>
              <em class="error invalid-feedback">{{ validateErrors.first('Body') }}</em>
            </div>
            <div><em class="text-primary">#DATE# : will be replaced with actual date in 'Day, Month dd, yyyy.' format</em></div>
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col>
            <label>From</label>
            <b-form-input id="inpPVIRptFrom" type="text" v-model="setting.EMAIL_FROM" :maxlength="150"
                          v-validate="{required: true}"
                          v-bind:class="{'is-invalid': validateErrors.has('From') }"
                          name="From"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col>
            <label>CC</label>&nbsp;&nbsp;&nbsp;<em class="text-primary">(Add multiple emails by comma separation)</em>
            <b-form-input id="inpPVIRptCC" type="text" v-model="setting.EMAIL_CC" :maxlength="150" name="CC"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col>
            <label>BCC</label>&nbsp;&nbsp;&nbsp;<em class="text-primary">(Add multiple emails by comma separation)</em>
            <b-form-input id="inpPVIRptBcc" type="text" v-model="setting.EMAIL_BCC" :maxlength="150" name="BCC"></b-form-input>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <loading :show="boolLoading" :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import Store from '@/store'
import cSwitch from '../components/Switch'
import notify from 'devextreme/ui/notify'
import {
  DxNumberBox
} from 'devextreme-vue'
import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxItem
} from 'devextreme-vue/html-editor'
export default {
  name: 'PVIEmailSettings',
  components: {
    loading,
    cSwitch,
    DxNumberBox,
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxItem
  },
  created () {
    this.initLoad = true
    let self = this
    self.loadPVIReportSettings()
  },
  data () {
    return {
      errMsg: '',
      initLoad: true,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      isInternalStaff: Store.state.isInternalStaff,
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      headerValues: [false, 1, 2, 3, 4, 5],
      setting: {},
      blanksetting: {
        REPORT_ROWS: 20,
        IS_ACTIVE: true,
        EMAIL_REPORT: true,
        EMAIL_REPORT_ROWS: 5,
        EMAIL_REPORT_NAME: 'pvi_report',
        EMAIL_SUBJECT: 'National Average PVI Report',
        EMAIL_BODY: 'Hello,<br/><br/>Please find attached an Excel file containing the National Average PVI Report data for #DATE#.<br/><br/>Thanks,<br/>Market Scan Information Systems, Inc.',
        EMAIL_FROM: 'noreply@marketscan.com',
        EMAIL_CC: 'development@marketscan.com, qa@marketscan.com',
        EMAIL_BCC: 'support@marketscan.com, alfredo@marketscan.com'
      }
    }
  },
  methods: {
    loadPVIReportSettings () {
      let self = this
      axios.get('/api/pvi/getpviemailsettings')
        .then(response => {
          if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
            if (response.data !== undefined) {
              // console.log(`loadPVIReportSettings ${JSON.stringify(response)}`)
              self.setting = response.data
            } else {
              self.setting = self.blanksetting
            }
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
        })
    },
    savePVIReportSettings () {
      let self = this
      Promise.all([
        self.$validator.validate('Results per class', self.setting.EMAIL_REPORT_ROWS),
        self.$validator.validate('Subject', self.setting.EMAIL_SUBJECT),
        self.$validator.validate('Body', self.setting.EMAIL_BODY),
        self.$validator.validate('From', self.setting.EMAIL_FROM)
      ]).then(values => {
        if (values.every(value => { return value })) {
          let obj = {
            pvireportsettings: self.setting
          }
          axios.post('/api/pvi/savepviemailsettings', obj)
            .then(response => {
              this.boolLoading = false
              // self.setting = response.data
              this.changesSaved = true
              notify('Settings has been saved', 'success', 3500)
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }

              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
            })
        }
      })
    },
    GetError (param) {
      let self = this
      let err = self.validateErrors.first(param)
      if (err !== undefined) {
        return { message: err }
      }
      return undefined
    },
    HasError (param) {
      let self = this
      if (self.validateErrors.first(param) !== undefined) {
        return false
      }
      return true
    }
  },
  computed: {},
  watch: {},
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>
<style>
  .dx-quill-container {
    border-style: solid;
    border-width: thin;
    border-color: #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/views/PVIEmailSettings.vue